import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './packageTypes.state';
import getters from './packageTypes.getters';
import actions from './packageTypes.actions';
import mutations from './packageTypes.mutations';

BaseStore.registerModule('packageTypes', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('packageTypes');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};